module.exports = __webpack_public_path__ + "static/img/charm_level_96.a9a7767.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_96.png
// module id = 19oC
// module chunks = 0